import { initializeAnalytics as baseInitializeAnalytics } from '@chilecompra/react-kit'
import GoogleAnalytics from 'react-ga'
import {
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION
} from './environment'

/**
 * To initialize the analytics tools.
 */
const initializeAnalytics = () => {
  baseInitializeAnalytics({
    gaKey: REACT_APP_GOOGLE_ANALYTICS_KEY,
    gaKeySV: REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
    gtmId: REACT_APP_GOOGLE_TASK_MANAGER_KEY,
    hotjarId: REACT_APP_HOTJAR_ID,
    hotjarSV: REACT_APP_HOTJAR_SNIPPET_VERSION
  })
}

export const sendAnalyticsEvent = event => {
  GoogleAnalytics.event(event)
}

export default initializeAnalytics
